import { useCurrentLanguage } from 'tradera/lang/translate';

type AppLinks = {
    [key: string]: {
        appStore: string;
        googlePlay: string;
    };
};

const appLinks: AppLinks = {
    sv: {
        appStore:
            'https://apps.apple.com/se/app/tradera-köp-och-sälj/id427984084',
        googlePlay:
            'https://play.google.com/store/apps/details?id=com.tradera&hl=sv',
    },
    da: {
        appStore:
            'https://apps.apple.com/dk/app/tradera-køb-og-sælg/id427984084?l=da',
        googlePlay:
            'https://play.google.com/store/apps/details?id=com.tradera&hl=da&gl=DK',
    },
    en: {
        appStore: 'https://apps.apple.com/us/app/tradera-buy-sell/id427984084',
        googlePlay:
            'https://play.google.com/store/apps/details?id=com.tradera&hl=en',
    },
    de: {
        appStore:
            'https://apps.apple.com/de/app/tradera-kaufen-und-verkaufen/id427984084',
        googlePlay:
            'https://play.google.com/store/apps/details?id=com.tradera&hl=de',
    },
    fr: {
        appStore:
            'https://apps.apple.com/fr/app/tradera-k%C3%B6p-s%C3%A4lj-begagnat/id427984084',
        googlePlay:
            'https://play.google.com/store/apps/details?id=com.tradera&hl=fr',
    },
    nl: {
        appStore:
            'https://apps.apple.com/nl/app/tradera-k%C3%B6p-s%C3%A4lj-begagnat/id427984084',
        googlePlay:
            'https://play.google.com/store/apps/details?id=com.tradera&hl=nl',
    },
};

export const useAppDownloadLink = () => {
    const { language: preferredLanguage } = useCurrentLanguage();
    const language = preferredLanguage?.toLowerCase();

    if (appLinks[language]) {
        return appLinks[language];
    }

    return appLinks['sv'];
};
